module.exports = __webpack_public_path__ + "static/media/PermInstall.f8713623.svg";